import { Alert } from "@mui/material";
import React from "react";

export interface IMinimalInfoAlertProps {
    filled?: boolean;
    typographyVariant?: "detail1" | "label1";
}

export const MinimalInfoAlert: React.FC<React.PropsWithChildren<IMinimalInfoAlertProps>> = ({
    filled,
    typographyVariant = "label1",
    children,
}) => (
    <Alert
        severity="info"
        sx={(theme) => ({
            ...theme.typography[typographyVariant],
            background: filled ? theme.palette.backgroundColors.cardTertiary.main : "inherit",
            color: filled ? theme.palette.common.black : theme.palette.text.secondary,
            px: 1,
            py: 0,
            "& .MuiAlert-icon": {
                fontSize: 14,
                color: filled ? theme.palette.common.black : theme.palette.text.secondary,
                mr: 1,
                pt: 1,
            },
        })}
    >
        {children}
    </Alert>
);
